import { Component, OnInit } from '@angular/core';
import { Widget, Dashboard } from 'src/api/models'
import { IWidgetEditor, WidgetType, MediaWidget } from 'src/app/models/dashboard';

@Component({
  selector: 'app-media-player-widget-editor',
  templateUrl: './media-player-widget-editor.component.html',
  styleUrls: ['./media-player-widget-editor.component.css']
})
export class MediaPlayerWidgetEditorComponent implements OnInit, IWidgetEditor {
  public widgetType: WidgetType;
  public widget: MediaWidget;
  public dashboard: Dashboard;
  public w: any;
  
  constructor() {}

  ngOnInit() {
    this.w = <any>this.widget;
    if (this.w.timeSeriesList == null) { 
      this.w.timeSeriesList = [];
    } 
    
    if (this.w.timeSeriesList.length === 0) {
      this.w.timeSeriesList.push({ uri: "" });
    }
  }
}
